import { Component, Inject, OnInit, Renderer2 } from '@angular/core';

declare function fetchImageDataURL(): any;

@Component({
  selector: 'app-drag-canvas',
  templateUrl: './drag-canvas.component.html',
  styleUrls: ['./drag-canvas.component.css']
})
export class DragCanvasComponent implements OnInit {

  constructor(
    private renderer2: Renderer2) { }

  ngOnInit(): void {
    const s = this.renderer2.createElement('script');
    s.onload = this.loadNextScript.bind(this);
    s.type = 'text/javascript';
    s.src = 'assets/js/konva.min.js';
    s.text = ``;
    this.renderer2.appendChild(document.body, s);
  }

  resetCanvas() {
    const s = this.renderer2.createElement('script');
    s.text = `resetImage()`;
    this.renderer2.appendChild(document.body, s);
  }

  selectSizeLabel(url: string) {
    const s = this.renderer2.createElement('script');
    s.text = `selectSizeLabel("` + url + `")`;
    this.renderer2.appendChild(document.body, s);
  }

  refreshCanvas() {
    const s = this.renderer2.createElement('script');
    s.text = `refreshImage()`;
    this.renderer2.appendChild(document.body, s);
  }

  fetchImageDataURL() {
    let dataURL = fetchImageDataURL();
    return dataURL;
  }

  loadNextScript() {
    const s = this.renderer2.createElement('script');
    s.text = `
    var isGalleryImage = false;

    //******* Set up the stage
    var stage = new Konva.Stage({
      container: 'container',
      width: 300,
      height: 125
    });

    var layer = new Konva.Layer();
    stage.add(layer);


      //******* Set property of the images
      var uplodedImage = new Konva.Image({draggable: true});
    
      var imgObject = new Image();
      imgObject.onload = function () {

        if(!isGalleryImage)
        {
         let newImgWidth;
         let newImgHeight;
         
         let stageWidth = stage.width() / 1.2;
         let stageHeight = stage.height() / 1.2;
         const canvasRatio = stageWidth / stageHeight;
         
         const imgWidth = imgObject.width;
         const imgHeight = imgObject.height;
         const imgAspectRatio =  imgWidth / imgHeight;
         
         
         if (imgAspectRatio >= canvasRatio) {
           newImgWidth = stageWidth;
           newImgHeight = stageWidth / imgAspectRatio;
         } else {
           newImgWidth = stageHeight * imgAspectRatio;
           newImgHeight = stageHeight;
         }
         
         //set image properties
         uplodedImage.x((stage.width() - newImgWidth)/2);
         uplodedImage.y((stage.height() - newImgHeight)/2);
         uplodedImage.height(newImgHeight);
         uplodedImage.width(newImgWidth);
         uplodedImage.offsetX(0);
         uplodedImage.offsetY(0);
         uplodedImage.rotation(0);
         uplodedImage.skewX(0);
         uplodedImage.skewY(0);
         uplodedImage.scaleX(1);
         uplodedImage.scaleY(1);
        }
        else {
         uplodedImage.x(0);
         uplodedImage.y(0);
         uplodedImage.height(stage.height());
         uplodedImage.width(stage.width());
        }

      uplodedImage.image(imgObject);
      layer.add(uplodedImage);
      layer.draw();
    };


    //*******set image trasnformation
    var imageSelection = new Konva.Transformer({
      nodes: [uplodedImage],
      keepRatio: true,     
      borderDash: [3, 3],
      rotateEnabled: false,
      centeredScaling: false,
      borderEnabled :true,
      anchorSize : 10,
      enabledAnchors:[
         'top-left',
         'top-center',
         'top-right',
         'middle-right',
         'middle-left',
         'bottom-left',
         'bottom-center',
         'bottom-right']
    });

    layer.add(imageSelection);
    

   //****** select a previously added size label
   function selectSizeLabel(url){
        isGalleryImage = true;
        imgObject.crossOrigin = 'Anonymous';
        imgObject.src = url;
        refreshImage();
        layer.draw();
        $(".upload-btn-wrapper").hide();
        $(".delete-icon").show();
    }

    //******* on reset image 
    function resetImage(){
      isGalleryImage = false;
      imageSelection.borderEnabled(false);
      imageSelection.anchorSize(0);
      $(".delete-icon").hide();
    }

    resetImage();

    //******* refresh image 
    function refreshImage(){
      imageSelection.borderEnabled(true);
      imageSelection.borderDash([3, 3]);    
      imageSelection.anchorSize(10);
      imageSelection.enabledAnchors([
        'top-left',
         'top-center',
         'top-right',
         'middle-right',
         'middle-left',
         'bottom-left',
         'bottom-center',
         'bottom-right'
      ]);
    }


   //******* handle image on drag drop and change
    function handleImage(file){
      if (validateImage(file))
      {
        var URL = window.webkitURL || window.URL;
        var url = URL.createObjectURL(file);
        imgObject.src = url;
        refreshImage();
        layer.draw();
        $(".upload-btn-wrapper").hide();
        $(".delete-icon").show();
      }
    }


    //******* on click delete image
    $(".delete-icon").click(function(e){
      isGalleryImage = false;
      imgObject.src = '';
      resetImage();
      layer.draw();
      $(".upload-btn-wrapper").show();
      $(".delete-icon").hide();
    });



    
    //****** where files are dropped + file selector is opened
    var dropRegion = document.getElementById("drop-region");

    //****** open file selector when clicked on the drop region
    var fakeInput = document.createElement("input");
    fakeInput.type = "file";
    fakeInput.accept = "image/*";
    fakeInput.multiple = false;
    dropRegion.addEventListener('click', function() {
      fakeInput.click();
    });

    fakeInput.addEventListener("change", function() {
      var files = fakeInput.files;
      handleImage(files[0]);
    });

    function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    dropRegion.addEventListener('dragenter', preventDefault, false);
    dropRegion.addEventListener('dragleave', preventDefault, false);
    dropRegion.addEventListener('dragover', preventDefault, false);
    dropRegion.addEventListener('drop', preventDefault, false);


    //******* handle the drop
    function handleDrop(e) {
      var dt = e.dataTransfer,
      files = dt.files;
    
      if (files.length) {  
        handleImage(files[0]);
      }
      else{
        alert("Invalid file");
      }
    }
    
    dropRegion.addEventListener('drop', handleDrop, false);


    //******* validating the image size and type etc.
    function validateImage(image) {
      // check the type
      var validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (validTypes.indexOf( image.type ) === -1) {
        alert("Invalid File Type");
        return false;
      }

      // check the size
      var maxSizeInBytes = 10e6; // 10MB
      if (image.size > maxSizeInBytes) {
        alert("File should not be greater than 10 MB");
        return false;
      }

      return true;
    }

    function fetchImageDataURL(){
      var dataURL = stage.toDataURL({ pixelRatio: 6 });
      return dataURL;
    } 
    `
    this.renderer2.appendChild(document.body, s);
  }
}
